import * as React from 'react';
import Divider, { type DividerProps } from '@mui/material/Divider';

export type MenuDividerProps = DividerProps;

/**
 * MenuDivider wrapper - simple wrapper around MUI Divider
 */
const MenuDivider = React.forwardRef<HTMLHRElement, MenuDividerProps>((props, ref) => {
  return <Divider ref={ref} {...props} />;
});

MenuDivider.displayName = 'MenuDivider';

export default MenuDivider;
